import React from 'react';

import {
    DataCondition,
    DataExportFormat,
    DataFilters,
    DataGranularity,
    DataGranularityKey,
    DataResponse,
    DataType,
} from '@portal/common/types';
import { getFirstSupportedDataResponse } from '@portal/common/utility/chart-data-helpers';

import Chart from './Chart';

type Props = {
    initialTimeUnitValue: number | string;
    conditionsDataTypes: DataType[];
    conditionsDataTypesGranularity: DataGranularity;
    conditionsPrimaryEntityFilters: DataGranularityKey[];

    dataResponses: null | Record<string, DataResponse>;
    isLoadingData: boolean;
    filtersValues: DataFilters;
    conditions: DataCondition[];
    chartFilters: DataFilters;

    timeUnitKey: DataGranularityKey;
    onExportData?: (format: DataExportFormat) => void;
    enableExportPNG: boolean;
    numberFormatter: (value: number | string) => string;

    echartsMapKey: string;
    isDengueTool: boolean;
    theme?: any;
};

export default React.forwardRef<Props>(({ dataResponses, ...props }, ref) => (
    <Chart ref={ref} {...props} dataResponse={getFirstSupportedDataResponse(dataResponses)} />
));
